import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Add as AddIcon } from '@mui/icons-material';

import { NavigateLinks, GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { PaginationConfig } from '@/components/table/TablePagination';

import { serviceVisitTypesBreadcrumbs } from './config';
import { ServiceVisitTypesTable, ServiceVisitTypesSearchBar } from './components';
import { useServiceVisitTypes } from './hooks';

const ServiceVisitTypes = () => {
  const navigate = useNavigate();

  const breadcrumbs = useMemo(
    () => serviceVisitTypesBreadcrumbs(navigate).slice(0, -1),
    [navigate]
  );

  const {
    items,
    totalItems,
    totalPages,
    page,
    pageSize,
    filters,
    initialFilter,
    isLoading,
    isFetching,
    error,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
  } = useServiceVisitTypes();

  const pagination: PaginationConfig = {
    totalItems,
    totalPages,
    currentPage: page,
    rowsPerPage: pageSize,
    onPageChange: handlePageChange,
    onRowsPerPageChange: handleRowsPerPageChange,
  };

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks actualPage='Tipos de visita' breadcrumbs={breadcrumbs} />

      <div className='flex justify-end'>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('/business/service-visit-types/new')}
        >
          <AddIcon />
          Nuevo tipo de visita
        </GlobalButton>
      </div>

      <ServiceVisitTypesSearchBar
        initialFilter={initialFilter}
        filter={filters}
        search={handleSearch}
      />

      <ServiceVisitTypesTable
        items={items}
        isLoading={isLoading || isFetching}
        error={error}
        pagination={pagination}
      />
    </section>
  );
};

export default ServiceVisitTypes;
